import React, { useState, useRef, useEffect,  useCallback  } from "react";
import { withRouter } from "react-router";
import { makeStyles } from '@material-ui/core/styles';  
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import Webcam from 'react-webcam';
import {sendReactionScreenshots} from '../../../Utils'


//Cette page correspond à la page résultat, appelée après la première série uniquement.
//Après la première série, cette page annoncera la détection de triche (et poursuite de l'expérience avec série 2)
//A partir du moment où l'utilisateur voit l'annonce, une photo de l'utilisateur est prise toutes les demies-secondes.

function EmotionsPerformancesResults(props)  {
    

    const classes = useStyles();
    const history = useHistory();
    const [resultStage, setResultStage] = useState('triche')
    const [sanction, setSanction] = useState('')
    const sanctions = ['avertissement', "suite score nul", 'restart']

    useEffect(() => {
        if(props === undefined || props.location.user === undefined){
            history.push("/")
        }

        var timer = 0
        const intervalId = setInterval(() => {
            if(timer===0){ // Screenshot avant annonce pour photo de base.
                capture(timer)
            }
            timer = timer +1
            if ( timer === 1){
                setResultStage('triche')
            }
            if( timer < 10){
                capture(timer/2)
            }

        }, 500);//Prise de photo toutes les demies-secondes

        setSanction(getRandomSanction())//Choisit aléatoirement une sanction parmi les trois

        return () => {
            clearInterval(intervalId);
        };

    },[props])



    const getRandomSanction=()=>{
        const rand = Math.floor(Math.random() * Math.floor(3))
        return sanctions[rand]
    }

    const getPunished=()=>{
        setResultStage('sanction')
    }

    const acceptPunishment=()=>{
        history.push({
            pathname:"/experience/EmotionsPerformances",
            user : props.location.user,
            givenSanction : sanction,
            actualSerie: props.location.actualSerie
        })
    }



    const videoConstraints = {
        width: 550,
        height: 360,
        facingMode: "user"  
        };
        
    const webcamRef = useRef(null);
    const capture = useCallback(
        (timer) => {
            const imageSrc = webcamRef.current.getScreenshot({width: 550, height: 360});
            console.log(timer)
            if(imageSrc !== null){
                sendReactionScreenshots(props.location.user, timer, imageSrc )
            }
            
            
            
        },
        [webcamRef,props ]
    );


return (
    <div>   
    {(resultStage === "triche" )? 
      <div className={classes.announcementContainer}>
        <p className={classes.tricheText}>
          TRICHERIE DÉTECTÉE
        </p>
        <p className={classes.descriptionText}>
          À la suite de l'analyse de vos résultats, nous avons détecté une ou plusieurs tentatives de tricherie durant la première partie de ce test.
        </p>
        {resultStage === "triche" ?
          <Button variant="outlined" color="primary" onClick={getPunished}>Suivant</Button>
        :null}
      </div>
    :null}
    
    {resultStage === "sanction" ?  
      <div className={classes.announcementContainer}>
        <p className={classes.tricheText}>
          VOICI VOTRE SANCTION 
        </p>
        {sanction === "avertissement"?
          <div>
            <p className={classes.descriptionText}>
              Vous pouvez poursuivre le test en <b>conservant votre score accumulé</b> dans la section précédente. Prenez soin de <b>RESPECTER LES RÈGLES</b>. Tricher à nouveau invalidera complètement votre participation au test.
            </p>
          </div>
        :null}
        {sanction === "suite score nul"?
          <div>
            <p className={classes.descriptionText}>
              Vous pouvez poursuivre le test, mais <b>votre résultat de la section précédente a été ramené à 0</b>. Prenez soin de <b>RESPECTER LES RÈGLES</b>.Tricher à nouveau invalidera complètement votre participation au test.
            </p>
          </div>
        :null}
          {sanction === "restart"?
          <div>
            <p className={classes.descriptionText}>
              <b>Vous devez recommencer cette première partie à 0</b>, qui sera suivie d'une seconde partie ensuite. Prenez soin de <b>RESPECTER LES RÈGLES</b>. Tricher à nouveau invalidera complètement votre participation au test.
            </p>
          </div>
        :null}
        <Button style={{display:'inline-block'}} variant="outlined" color="primary" onClick={acceptPunishment}>Accepter</Button>
      </div>
    :null}


        <div >
            <Webcam
                audio={false}
                height={0}
                ref={webcamRef}
                mirrored={true}
                screenshotFormat="image/jpeg"
                width={0}
                videoConstraints={videoConstraints}
            />
      </div>
    </div>

)}


const useStyles = makeStyles({
    root: {
        display: 'flex',
        flex:1,
        flexDirection:"column",
    },
    tricheText:{
        color:'red',
        fontSize: 34,
        fontWeight: 600,
    },
    descriptionText: {
        fontSize: '2em',
    },
    announcementContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh"
    }

})

 
export default withRouter(EmotionsPerformancesResults);